import { Button } from '@/components/ui'
import type { TourStep } from './steps'

export interface TourStepActions {
  onBack: () => void
  onNext: () => void
  onSkip: () => void
  onAskNow: () => void
}

interface TourStepContentProps extends TourStepActions {
  step: TourStep
  number: number
  total: number
}

export const TourStepContent = ({
  step,
  number,
  total,
  onBack,
  onNext,
  onSkip,
  onAskNow,
}: TourStepContentProps) => {
  const isLast = number === total

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <p className="font-semibold text-sm">{step.title}</p>
        <p className="text-pretty text-muted-foreground text-sm">{step.body}</p>
      </div>
      <div className="flex items-center justify-between gap-2">
        <span className="text-muted-foreground text-xs">
          {number} of {total}
        </span>
        <div className="flex items-center gap-1">
          <Button theme="ghost" size="sm" onClick={onSkip}>
            Skip tour
          </Button>
          {number > 1 && (
            <Button theme="outline" size="sm" onClick={onBack}>
              Back
            </Button>
          )}
          {isLast && step.isChatStep && (
            <Button theme="outline" size="sm" onClick={onAskNow}>
              Ask now
            </Button>
          )}
          <Button size="sm" onClick={onNext}>
            {isLast ? 'Done' : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  )
}
